import { FileItem, FileUploader, FileUploaderOptions } from 'ng2-file-upload';

export const oneMb = 1024 * 1024;

export const buildFileUploader = ({
  allowedFileType,
  allowedMimeType,
  maxFileSizeInMb
}: {
  allowedFileType?: string[];
  allowedMimeType?: string[];
  maxFileSizeInMb?: number;
}) => {
  const uploaderOptions: FileUploaderOptions = {
    allowedFileType,
    allowedMimeType,
    url: '' // URL is required in TypeScript, but We don't use it with ng-file-upload
  };
  if (maxFileSizeInMb) {
    uploaderOptions.maxFileSize = oneMb * maxFileSizeInMb;
  }
  return new FileUploader(uploaderOptions);
};

export const buildFileUploadData = (file: FileItem | File): FormData => {
  const formData = new FormData();
  formData.append('files', getRawFile(file));
  return formData;
};

export const buildFilesUploadData = (files: (FileItem | File)[]): FormData => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', getRawFile(file));
  });
  return formData;
};

export const getRawFile = (file: FileItem | File): File => {
  if (file instanceof FileItem) {
    if (file.file.rawFile instanceof File) {
      return file.file.rawFile;
    }
    //file.rawFile is a HTMLInputElement. We don't currently use ng-file-upload this way
    //But just in case something changes in future; log error
    console.error('file.rawFile is not a blob. File upload may fail');
    return file.file.rawFile as unknown as File;
  }
  return file;
};
